import './styles/StandMessageConfirmationForm.css';

import type { FormInstance }   from 'antd';
import React                   from 'react';
import { AppFormComponent }    from 'components/App/AppForm';
import { Checkbox }            from 'antd';
import { Col }                 from 'antd';
import { Form }                from 'antd';
import { Input }               from 'antd';
import { Radio }               from 'antd';
import FormattedMessageWrapper from 'components/App/FormattedMessageWrapper';
import FormItemUpload          from 'components/App/FormItemUpload';
import Row                     from 'components/App/Row';
import MessageMediaModel       from 'models/MessageMediaModel';
import StandMessageModel       from 'models/StandMessageModel';
import { getIntl }             from 'utils/getIntl';
import handleFormError         from 'utils/handleFormError';
import MessageModel            from 'models/MessageModel';
import StandModel              from 'models/StandModel';

const intl = getIntl();

interface StandMessageConfirmationFormProps {
  message: MessageModel;
  model: StandMessageModel;
  onSuccess?: (standMessage: StandMessageModel) => void;
  stand: StandModel;
}

class StandMessageConfirmationForm extends AppFormComponent<StandMessageConfirmationFormProps> {
  public formRef: React.RefObject<FormInstance> = React.createRef<FormInstance>();

  public state: {
    confirmationWasteDisposal?: string;
  } = {
      confirmationWasteDisposal: undefined,
    };

  public componentDidMount() {
    const { model } = this.props;

    this.formRef.current?.setFieldsValue({
      confirmationCompany: model.get('confirmationCompany'),
      confirmationEmail: model.get('confirmationEmail'),
      confirmationFirstName: model.get('confirmationFirstName'),
      confirmationInvoicing: model.get('confirmationInvoicing'),
      confirmationLastName: model.get('confirmationLastName'),
      confirmationPhone: model.get('confirmationPhone'),
      confirmationStanding: model.get('confirmationStanding'),
      confirmationWasteDisposal: model.get('confirmationWasteDisposal'),
    });

    this.setState({
      confirmationWasteDisposal: model.get('confirmationWasteDisposal'),
    });
  }

  public render() {
    return (
      <Form ref={this.formRef}>
        <Row>
          <Col span={24}>
            <b>
              <FormattedMessageWrapper id="Personne responsable du stand :" />
            </b>
          </Col>

          <Col span={8}>
            <Form.Item
              label={intl.formatMessage({ id: "Nom" })}
              labelCol={{ span: 24 }}
              name="confirmationLastName"
              rules={[
                {
                  message: intl.formatMessage({ id: "Information manquante" }),
                  required: true,
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item
              label={intl.formatMessage({ id: "Prénom" })}
              labelCol={{ span: 24 }}
              name="confirmationFirstName"
              rules={[
                {
                  message: intl.formatMessage({ id: "Information manquante" }),
                  required: true,
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item
              label={intl.formatMessage({ id: "Société" })}
              labelCol={{ span: 24 }}
              name="confirmationCompany"
              rules={[
                {
                  message: intl.formatMessage({ id: "Information manquante" }),
                  required: true,
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item
              label={intl.formatMessage({ id: "Téléphone" })}
              labelCol={{ span: 24 }}
              name="confirmationPhone"
              rules={[
                {
                  message: intl.formatMessage({ id: "Information manquante" }),
                  required: true,
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item
              label={intl.formatMessage({ id: "Courriel" })}
              labelCol={{ span: 24 }}
              name="confirmationEmail"
              rules={[
                {
                  message: intl.formatMessage({ id: "Information manquante" }),
                  required: true,
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>

          <Col span={24}>
            <div className="NewMessageFormWithConfirmationPart__frenchTitle">
              <FormattedMessageWrapper id="Confirmation de la validation du projet de votre stand" />
            </div>
          </Col>

          <Col span={24}>
            <div style={{ display: 'flex', marginBottom: '1em' }}>
              <div style={{ marginRight: '10px', minWidth: '30px' }}>
                <Form.Item
                  name="confirmationStanding"
                  rules={[
                    {
                      message: intl.formatMessage({ id: "Information manquante" }),
                      required: true,
                      transform: value => value || undefined,
                      type: 'boolean',
                    },
                  ]}
                  valuePropName="checked"
                >
                  <Checkbox />
                </Form.Item>
              </div>
              <div>
                <p className="text-bold">
                  <FormattedMessageWrapper
                    id="En cochant cette case, j'atteste que ce(s) plan(s) font référence pour la construction de notre stand et je reconnais avoir pris connaissance des points cités ci-dessous." />
                </p>
                <p className="text-bold text-italic">
                  <FormattedMessageWrapper
                    id="Conformément au décret n°94-86 du 26 janvier 1994 et au règlement du salon tout stand construit avec un plancher doit être équipé d'une rampe permettant l'accès pour les personnes à mobilité réduite." />
                </p>
              </div>
            </div>
          </Col>

          <Col span={24}>
            <div className="NewMessageFormWithConfirmationPart__frenchTitle">
              <FormattedMessageWrapper id="ATTESTATION DE DÉMONTAGE" />
            </div>
          </Col>

          <Col span={24}>
            <div style={{ display: 'flex', marginBottom: '1em' }}>
              <div style={{ marginRight: '10px', minWidth: '30px' }} />
              <div>
                <div className="NewMessageFormWithConfirmationPart__label">
                  <FormattedMessageWrapper id="L’évacuation des déchets de notre stand sera assurée par" />
                </div>
                <div>
                  <Form.Item
                    name="confirmationWasteDisposal"
                    rules={[
                      {
                        message: intl.formatMessage({ id: "Information manquante" }),
                        required: true,
                      },
                    ]}
                  >
                    <Radio.Group
                      onChange={event => {
                        this.setState({
                          confirmationWasteDisposal: event.target.value,
                        });
                      }}
                      options={[
                        {
                          label: intl.formatMessage({ id: "Nous-mêmes" }),
                          value: 'WASTE_DISPOSAL_OURSELVES',
                        },
                        {
                          label: intl.formatMessage({ id: "Le décorateur" }),
                          value: 'WASTE_DISPOSAL_DECORATOR',
                        },
                        {
                          label: intl.formatMessage({ id: "Une société de nettoyage" }),
                          value: 'WASTE_DISPOSAL_CLEANING_COMPANY',
                        },
                      ]}
                    />
                  </Form.Item>
                </div>
                {this.state.confirmationWasteDisposal === 'WASTE_DISPOSAL_CLEANING_COMPANY' && (
                  <FormItemUpload
                    label={intl.formatMessage({ id: "Nous joindre impérativement la copie de votre bon de commande" })}
                    name="wasteDisposalCleaningCompanyAttachment"
                  />
                )}
                <div>
                  <p className="text-bold">
                    <FormattedMessageWrapper
                      id="Conformément au règlement du salon, votre emplacement doit être restitué dans l’état initial. Tous les détritus (moquette,adhésifs, éléments de décoration divers…) doivent être retirés, les dégâts constatés lors du démontage des stands seront facturés à l’exposant. L’exposant est aussi responsable pour l’ensemble de ses prestataires." />
                  </p>
                </div>
              </div>
            </div>
          </Col>

          <Col span={24}>
            <div style={{ display: 'flex', marginBottom: '1em' }}>
              <div style={{ marginRight: '10px', minWidth: '30px' }}>
                <Form.Item
                  name="confirmationInvoicing"
                  rules={[
                    {
                      message: intl.formatMessage({ id: "Information manquante" }),
                      required: true,
                      transform: value => value || undefined, // Those two lines
                      type: 'boolean',
                    },
                  ]}
                  valuePropName="checked"
                >
                  <Checkbox />
                </Form.Item>
              </div>
              <div>
                <p>
                  <FormattedMessageWrapper
                    id="J'ai bien noté que le non respect de ce règlement entrainera une facturation supplémentaire." />
                </p>
                <p>
                  <FormattedMessageWrapper
                    id="Sans validation de ce formulaire de votre part votre engagement à respecter la réglementation du salon sera sans aucune prise en compte de dérogation et définitif." />
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </Form>
    );
  }

  public submit = async () => {
    const {
      message,
      model,
      onSuccess,
      setSaveButtonProps,
      stand,
    } = this.props;

    const values = await this.formRef.current?.validateFields();

    setSaveButtonProps({ loading: true });

    try {
      const attachments = [];

      if (values.wasteDisposalCleaningCompanyAttachment) {
        const messageMedia = await this.uploadMessageMedia(
          values.wasteDisposalCleaningCompanyAttachment[0].originFileObj,
        );
        attachments.push(messageMedia.data['@id']);
      }

      await message.patch({
        attachments,
        content: values.content,
      });

      await model.patch({
        confirmationCompany: values.confirmationCompany,
        confirmationEmail: values.confirmationEmail,
        confirmationFirstName: values.confirmationFirstName,
        confirmationInvoicing: values.confirmationInvoicing,
        confirmationLastName: values.confirmationLastName,
        confirmationPhone: values.confirmationPhone,
        confirmationStanding: values.confirmationStanding,
        confirmationWasteDisposal: values.confirmationWasteDisposal,
        message: message.iri,
        newStandStatus: model.newStandStatus,
        stand: stand.iri,
      });

      if (onSuccess) {
        onSuccess(model);
      }
    } catch (error) {
      handleFormError(error, this.formRef.current);
    } finally {
      setSaveButtonProps({ loading: false });
    }
  };

  private uploadMessageMedia = async (file: any) => {
    const messageMediaModel = new MessageMediaModel();

    messageMediaModel.set({
      enabled: true,
      file,
    });

    await messageMediaModel.save();

    return messageMediaModel;
  };
}

export default StandMessageConfirmationForm;
